module.exports = __webpack_public_path__ + "legal/KİŞİSEL VERİLERİN SİLİNMESİ YÖNETMELİK.ef34c732.pdf";